import { isEmpty } from "lodash-es"

const envPackageVersion = import.meta.env.VITE_APP_PACKAGE_VERSION
const envVersionOverride = import.meta.env.LH_TIMP_VERSION

/**
 * Strip the prerelease tag from the package version.
 * This is used to ensure that the version displayed in the app does not include
 * any pre-release identifiers (like `-alpha`, `-beta`, etc.) that are
 * typically used during development or testing phases.
 */
const packageVersionWithoutPrereleaseTag = envPackageVersion.replace(/-.*$/, '')

export const APP_VERSION = isEmpty(envVersionOverride)
  ? packageVersionWithoutPrereleaseTag
  : envVersionOverride
